<template>
  <div class="card-bundle">
    <div class="div-img">
      <img :src="bundle.main_image" :alt="bundle.title" class="img-responsive center-block">
    </div>
    <div class="card-bundle-body">
      <h6 class="card-title">{{bundle.title}}</h6>
      <h5 class="description-text">{{bundle.description}}</h5>
      <template v-if="bundle.promotional_price">
        <p>
          <small><strike>R$ {{bundle.price}}</strike></small>
        </p>
        <p class="price">R$ {{bundle.promotional_price}}</p>
      </template>
      <template v-else>
        <p class="price">R$ {{bundle.price}}</p>
      </template>
      <star-rating
        :star-size="20"
        :rating="bundle.rating"
        :show-rating="false"
        :read-only="true"
        :increment="0.5"
      ></star-rating>
      <a :href="bundle.link_show" class="btn btn-purchase">COMPRAR</a>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'card',

    props: {
      bundle: Object,
    },
  };
</script>
<style scoped>
  .card-bundle-body p {
    margin: 0;
  }

  .card-bundle-body {
    padding: 10px;
    font-family: 'Montserrat', "Helvetica Neue", sans-serif;
    color: #24323b;
  }

  .price {
    font-size: 18px;
    padding-top: 18px;
    font-weight: 400;
    color: #384853;
  }

  .card-bundle {
    overflow: hidden;
    margin: 10px;
    background-color: white;
  }

  .btn-purchase:hover {
    background-color: #e6bc00;
  }

  .btn-purchase {
    padding-top: 8px;
    width: 100%;
    margin-top: 10px;
    border-radius: 0;
    background-color: #FFD400;
    color: #333333;
    height: 38px;
    font-family: 'Montserrat', "Helvetica Neue", sans-serif;
  }

  .card-title {
    font-size: 15px;
    font-weight: 300;
  }

  .div-img {
    min-height: 373px;
  }

  .description-text {
    min-height: 75px;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/store/components/CardBundle.vue